import React, { memo, useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ReactECharts from "echarts-for-react";
import { formatNumber, getShortenMark, shortenNumberAutoK } from "../../helpers/utils";
import { useAxios } from "../../helpers/apiHelper";
import { indexActionTypes, updateDerivativeChart } from "../../redux/actions/indexActions";
import { wsMsgSeparatorChar } from "../../helpers/websocketHelper";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highstock";

export default memo(
  function StockDerivativeDetail(props) {
    const { symbolInfo, indexCode } = props;

    const { t } = useTranslation();
    const refChart = useRef(null);
    const axios = useAxios();
    const dispatch = useDispatch();

    const language = useSelector((state) => state.gShared.language);
    const chartDatas = useSelector((state) => state.gIndex.derivativeChart);
    const serverTime = useSelector((state) => state.gShared.serverTime);
    const serverDate = serverTime > 0 ? new Date(serverTime) : new Date();
    const [initDatas, setInitDatas] = useState("");

    // khoi tao data
    useEffect(async () => {
      getDataChart();

      const _intervalId = setInterval(getDataChart, 30000);
      return () => {
        clearInterval(_intervalId);
      };
    }, []);

    const getDataChart = async () => {
      try {
        const response = await axios.get(`api/derivative/get-chart?p_symbol=${symbolInfo?.code}`);
        if (response && response.status === 200) {
          // let storedDataChartInfos = { counter: 0, datas: [] };

          // let storedDatasByIndexCode = storedDataChartInfos ?? { counter: 0, datas: [] };
          // let msgDatasByTime = response?.data.split(wsMsgSeparatorChar.PropSeparatorChar);
          // for (let _msgIdx = 0; _msgIdx < msgDatasByTime.length; _msgIdx++) {
          //   if (msgDatasByTime[_msgIdx] === "") {
          //     continue;
          //   }

          //   const propDatas = msgDatasByTime[_msgIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
          //   const time = propDatas[0];
          //   let datas = storedDatasByIndexCode.datas ?? [];
          //   const idx = datas.findIndex((el) => el.time === time);

          //   if (idx < 0) {
          //     datas.push({
          //       timeStamp: propDatas[1],
          //       price: propDatas[2],
          //       diff: propDatas[3],
          //     });
          //   } else {
          //     datas[idx].timeStamp = propDatas[1];
          //     datas[idx].price = propDatas[2];
          //     datas[idx].diff = propDatas[3];
          //   }

          //   storedDatasByIndexCode.datas = datas;
          //   storedDatasByIndexCode.counter += 1;
          // }
          // setInitDatas(response?.data);

          //console.log(response?.data, "response?.data");
          setInitDatas(response?.data);
        }
      } catch (error) {
        console.error(error);
      }
    }

    const _getChartOptions = () => {
      var arrHoursTicks = [9, 10, 11, 12, 13, 14, 15];
      var arrIndexval = [];
      var arrDolech = [];
      var arrTicksDisplay = [];

      for (let t = 0; t < arrHoursTicks.length; t++) {
        const tickDate = serverDate;
        tickDate.setHours(arrHoursTicks[t], 0, 0);
        const timeStampFromTickDate = tickDate.getTime();
        arrTicksDisplay[t] = timeStampFromTickDate;
      }

      if (initDatas !== null && initDatas !== "") {
        var arrDataTemp = initDatas?.split("|");
        if (arrDataTemp !== null && arrDataTemp.length > 0) {
          for (var i = 0; i < arrDataTemp.length; i++) {
            if (arrDataTemp[i] !== "") {
              var arrChild = arrDataTemp[i]?.split("*");
              var _time = parseFloat(arrChild[1]);
              var _dolech = arrChild[2] !== "" ? parseFloat(arrChild[2]) : null;
              var _indexval = arrChild[3] !== "" && arrChild[3] != "0" ? parseFloat(arrChild[3].replace(",", "")) : null;
              //
              arrIndexval.push({ x: _time, y: _indexval });
              arrDolech.push({ x: _time, y: _dolech });
            }
          }
          arrIndexval = arrIndexval.sort(function (a, b) {
            return a.x - b.x;
          });
          arrDolech = arrDolech.sort(function (a, b) {
            return a.x - b.x;
          });
        }
      }

      Highcharts.setOptions({
        global: {
          //timezoneOffset: -7 * 60, // Đặt múi giờ mong muốn
          useUTC: false
        },
        lang: {
          timezone: 'GMT', // Đặt nhãn thời gian là GMT
          thousandsSep: ',',
          decimalPoint: '.'
        }
      });

      //console.log(arrTicksDisplay, "arrTicksDisplayarrTicksDisplay");

      return {
        chart: {
          plotBorderWidth: 1,
          plotBorderColor: "#9a9a9a",
          height: 300,
          width: 700,
          backgroundColor: "#191919",
          style: { fontFamily: "Arial, Helvetica, sans-serif", color: "#9a9a9a" },
          // events: {
          //   load() {
          //     var _currChart = this;
          //     console.log(_currChart, "_currChart");
          //     if (!arrIndexval || arrIndexval.length === 0 || !arrDolech || arrDolech.length === 0) {
          //       return;
          //     }

          //     for (let i = 0; i < initDatas.length; i++) {
          //       // const element = array[i];

          //     }

          //     setInterval(() => {

          //     }, 3000); //30000
          //   }
          // }
        },

        navigator: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        rangeSelector: {
          selected: 5,
          enabled: false,
          inputEnabled: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          tickmarkPlacement: "on",
          type: "datetime",
          startOnTick: true,
          endOnTick: true,
          tickPositions: arrTicksDisplay,
          tickLength: 5,
          tickColor: "#9a9a9a",
          gridLineColor: "#9a9a9a",
          lineColor: "#9a9a9a",
          dateTimeLabelFormats: {
            millisecond: "%M:%S:%L",
            second: "%H:%M:%S",
            minute: "%H:%M",
            hour: "%H",
            day: "%d-%m-%Y",
            week: "%d-%m-%Y",
            month: "%m-%Y",
            year: "%Y",
          },
          title: {
            y: 0,
          },
          labels: {
            style: { color: "#9a9a9a" },
            rotation: -0,
            range: 3600 * 1000,
            formatter: function () {
              return Number(Highcharts.dateFormat('%H', this.value)) + "h";
            }
            // formatter: function () { 
            //   const utcDate = new Date(this.value);
            //   const gmtPlus7Date = new Date(utcDate.getTime() + 7 * 60 * 60 * 1000);
            //   const hours = gmtPlus7Date.getUTCHours();

            //   return `${hours}h`;
            // },
          },
        },
        yAxis: [
          {
            labels: {
              style: { color: "#9a9a9a" },
            },
            title: {
              text: "",
            },
            height: "65%",
            resize: {
              enabled: true,
              lineWidth: 1,
              lineColor: "#9a9a9a",
            },
            opposite: false,
            tickColor: "#9a9a9a",
            gridLineWidth: 0,
            gridLineColor: "#9a9a9a",
            lineColor: "#9a9a9a",
          },
          {
            labels: {
              style: { color: "#9a9a9a" },
            },
            title: {
              text: "",
            },
            top: "65%",
            height: "35%",
            offset: 0,
            lineWidth: 1,
            opposite: false,
            tickColor: "#9a9a9a",
            gridLineWidth: 0,
            gridLineColor: "#9a9a9a",
            lineColor: "#9a9a9a",
            plotLines: [
              {
                value: 0,
                color: "yellow",
                dashStyle: "Dash",
                width: 1,
                zIndex: 11,
                label: {
                  text: "",
                  style: {
                    color: "#ffffff",
                  },
                  align: "center",
                },
              },
            ],
          },
        ],
        tooltip: {
          split: true,
          valueDecimals: 2, // Số chữ số thập phân
        },
        series: [
          {
            turboThreshold: arrIndexval.length,
            type: "spline",
            name: "Giá",
            lineWidth: 1,
            dataGrouping: {
              enabled: false,
            },
            color: "#fc0",
            data: arrIndexval,
          },
          {
            turboThreshold: arrDolech.length,
            type: "spline",
            name: "Độ lệch",
            lineWidth: 1,
            yAxis: 1,
            threshold: 0,
            dataGrouping: {
              enabled: false,
            },
            color: "#0f0",
            negativeColor: "#ff0000",
            data: arrDolech,
          },
        ],
      };
    };

    return initDatas && initDatas !== "" ? <HighchartsReact highcharts={Highcharts} constructorType={"stockChart"} options={_getChartOptions()} /> : <></>;
  },
  (prevProps, nextProps) => {
    if (prevProps.code === nextProps.code) {
      return true;
    }
    return false;
  }
);
